<template>
  <page>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Tariff Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-flex xs12 v-if="!tariffDialog">
        <message :messages="messages"></message>
      </v-flex>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.tarf }}</td>
          <td class="text-xs-left">{{ props.item.tarfDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Tariff<v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
    <v-dialog v-model="tariffDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">{{ labels.valueFormTitle }}</span>
          </v-card-title>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-card-text>
            <form>
              <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs6 v-if="newTariff">
                      <v-text-field v-model="tariffForm.tarf" :label="labels.tarf" :error-messages="errors.collect('tarf')" data-vv-name="tarf" :data-vv-as="labels.tarf" v-validate="'required|param|max:4'"></v-text-field>
                    </v-flex>
                    <v-flex xs6 v-else>
                      <v-subheader class="queryLabel">{{labels.tarf}}</v-subheader>
                      <div class="subheading">{{tariffForm.tarf}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field v-model="tariffForm.tarfDesc" :label="labels.tarfDesc" :error-messages="errors.collect('tarfDesc')" v-validate="'required|entry|max:40'" data-vv-name="tarfDesc" :data-vv-as="labels.tarfDesc"></v-text-field>
                    </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Tariff?
      <div class="title">{{deleteTariff}}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Tariff Code', value: 'tarf' },
        { text: 'Tariff Description', value: 'tarfDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Tariff Details',
        tarf: 'Tariff Code*',
        tarfDesc: 'Tariff Description*'
      },
      tariffForm: {
        tarf: null,
        tarfDesc: null
      },
      tariffDialog: null,
      newTariff: null,
      menu: [],
      promptRemove: false,
      deleteTariff: ''
    }
  },
  computed: {
    tariff() {
      return this.$store.state.parameters.tariff
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.tariff.menu.tariffs
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((tariff) => {
              const convertTariff = {
                tarf: tariff.tarf,
                tarfDesc: tariff.tarfDesc
              }
              this.items.push(convertTariff)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      await this.$store.dispatch('tariffInit')
      this.init()
    },
    async doReview(data) {
      this.tariffDialog = true
      this.newTariff = false
      const apiURI = this.tariff.menu.tariffGet
      const expand = {
        tarf: data.item.tarf
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.tariffForm.tarf = data.tariff.tarf
          this.tariffForm.tarfDesc = data.tariff.tarfDesc
          this.menu = extractMenu(result.data._links)
        }
        this.tariffDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newTariff = true
      this.tariffDialog = true
    },
    doClose() {
      this.newTariff = false
      this.tariffDialog = false
      this.tariffForm.tarf = null
      this.tariffForm.tarfDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newTariff) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.tariff.menu.tariffCreate
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.tariffForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            // this.message(data)
            // this.fieldMessage(data)
            this.errorMessage('Duplicate Tariff Found')
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.tariffUpdate
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.tariffForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTariff = data
        this.deleteTariff = data.tarf + ' - ' + data.tarfDesc
      }
    },
    async doRemove() {
      const apiURI = this.tariff.menu.tariffDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          tarf: this.selectedTariff.tarf
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Tariff')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
